import React, { Fragment, useEffect, useState } from "react";
import { Box, Button, Link, Stack, Typography } from "@mui/material";
import Carousel from 'react-elastic-carousel'
import ScholarshipsCards from "../../ScholarshipsCards";
import { getScholarships } from "../../../common/services/scholarships";
import Notification from "../../Notification";
import SchoolIcon from '@mui/icons-material/School';
import constants from "../../../config/constants";

const ScholarshipsOffer = ({ data }) => {

    const [scholarships, setScholarships] = useState([]);

    const scholarshipsAvailable = async () => {
        try {
            const convertedCityState = data.result.cidade.cityState.split(",")

            const uf_state = convertedCityState[1].trim();
            const city_name = convertedCityState[0].trim();
            const course_name = data.result.curso.baseCourseName;

            const response = await getScholarships(course_name, uf_state, city_name);
            const scholarships = response.data.data;

            setScholarships(scholarships);
        } catch (e) {
            Notification.error({
                message: 'Algo deu errado'
            });
        }
    };

    const redirectBedukaBolsas = () => {
        window.open(`${constants.BEDUKA_BOLSAS_WEB_URL}`)
    }

    useEffect(() => {
        scholarshipsAvailable();
    }, []);

    return (
        scholarships.length > 0 ?
            (<Fragment>
                <Box sx={{
                    margin: 'auto',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '10px'
                }}>
                    <Typography component={'span'} color="primary" sx={{ fontSize: '22px', fontWeight: '600' }}>
                        Algumas bolsas disponíveis:
                    </Typography>
                </Box>
                <Stack width={'100%'} mt={2}>
                    <Carousel itemsToShow={window.innerWidth >= 1250 ? 3 : window.innerWidth >= 800 ? 2 : 1} showArrows={false} >
                        {
                            scholarships.map((scholarship, index) => {
                                return (
                                    <Stack key={`stack ${index}`} sx={{ paddingTop: '10px', paddingBottom: '10px' }}>
                                        <ScholarshipsCards key={`scholarshipCard ${index}`} scholarshipData={scholarship} />
                                    </Stack>
                                )
                            })
                        }
                    </Carousel>
                </Stack>
            </Fragment>
            )
            :
            (
                <Fragment>
                    <Box sx={{
                        margin: 'auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '10px'
                    }}>
                        <Typography color={'primary'} sx={{ fontSize: '20px', fontWeight: '600' }}>
                            Você conhece o Beduka Bolsas?
                        </Typography>
                        <Button
                            variant="contained"
                            size="medium"
                            onClick={redirectBedukaBolsas}
                            endIcon={<SchoolIcon />}
                            sx={{
                                marginLeft: '10px',
                                backgroundColor: '#ee3db6'
                            }}
                        >
                            Saiba mais
                        </Button>
                    </Box>

                </Fragment>
            )
    )
}

export default ScholarshipsOffer;

